import axios from 'axios'

const BASE_URL = process.env.VUE_APP_API_BASE_URL

var API_PATH = BASE_URL + 'admin-role-privilieges/'

class AdminRolePriviliegeService {
  getCurrentUsersRolePriviliges () {
    return axios.get(API_PATH + 'current-user', { showLoader: false })
  }
}

export default new AdminRolePriviliegeService()
